<div class="persona-data-wrapper mt-3">
    <div class="container-fluid d-block d-sm-flex px-0">
        <div class="persona-column mx-auto">
            <div class="persona-header" [ngStyle]="{'background-color':block.data.col1colour}">
                {{block.data.col1heading}}
            </div>
            <div class="persona-row" *ngFor="let item of block.content; trackBy: trackByFn">
                <div class="persona-figure" [ngStyle]="{'color': block.data.col1colour}">{{item.data.col1rowfigure}}</div>
                <div class="persona-subtitle">{{item.data.col1rowsubtitle}}</div>
                <div class="persona-help">{{item.data.col1rowhelp}}</div>
            </div>
        </div>
        <div class="persona-column mx-auto mt-5 mt-sm-0 ml-md-auto">
            <div class="persona-header" [ngStyle]="{'background-color':block.data.col2colour}">
                {{block.data.col2heading}}
            </div>
            <div class="persona-row" *ngFor="let item of block.content; trackBy: trackByFn">
                <div class="persona-figure" [ngStyle]="{'color': block.data.col2colour}">{{item.data.col2rowfigure}}</div>
                <div class="persona-subtitle">{{item.data.col2rowsubtitle}}</div>
                <div class="persona-help">{{item.data.col2rowhelp}}</div>
            </div>
        </div>
    </div>
</div>


